export function formatDecimal(value: string | number, maxDecimals = 1): string {
  const num = typeof value === 'string' ? parseFloat(value) : value
  // Always use 'en-US' to ensure decimal separator is "." not ","
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: maxDecimals,
    minimumFractionDigits: 0,
  }).format(num)
}
